import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Sticky from 'react-stickynode';
import Media from 'react-media';

import ButtonIconSquare from '../../../common/zolaUI/ButtonIconSquare/ButtonIconSquare';
import ChecklistTaskNavigationButtons from '../ChecklistTaskNavigationButtons';
import ChecklistCompleteTaskButton from '../ChecklistCompleteTaskButton';
import ChecklistDeleteTaskButton from '../ChecklistDeleteButton';
import ChecklistAddTaskButton from '../ChecklistAddTaskButton';
import ChecklistInvitePartner from '../ChecklistInvitePartner';
import ChecklistFilterButton from '../ChecklistFilterButton';
import ChecklistOverflowMenu from '../ChecklistOverflowMenu/ChecklistOverflowMenu';

import { DESKTOP_MIN, TABLET_MAX } from '../../../../lib/responsive';

import './ChecklistNav.less';

const TOP_OFFSET = 60; // height of main nav

class ChecklistNav extends React.Component {
  handleDropdownSelect = (value) => {
    const { showSettingsModal, onInvitePartnerToggle } = this.props;
    switch (value) {
      case 'invitePartner':
        return onInvitePartnerToggle();
      case 'print':
        return this.handleOpenPrintTab();
      case 'settings':
        return showSettingsModal();
      default:
        return null;
    }
  };

  handleOpenPrintTab = () => {
    const { filterParams, trackPrintChecklistClick } = this.props;

    const newTab = window.open(`/wedding/print/checklist${filterParams}`, '_blank');
    newTab.opener = null;

    trackPrintChecklistClick();
  };

  render() {
    const { className, showSettingsModal, invitePartnerViewActive, onInvitePartnerToggle, filterParams, trackPrintChecklistClick } = this.props;

    const mobileOverflowMenuItems = [
      { id: 'invitePartner', label: 'Invite Partner', value: 'invitePartner' },
      { id: 'print', label: 'Print', value: 'print' },
      { id: 'settings', label: 'Settings', value: 'settings' }
    ];
    return (
      <Sticky top={TOP_OFFSET} className="checklist__nav-sticky-container" enableTransforms={false}>
        <div className={cx('checklist__nav-container', className)}>
          <div className="checklist__nav-container__left">
            <ChecklistFilterButton />
            <Media query={`(min-width: ${DESKTOP_MIN}px)`}>
              <div className="checklist__nav-container__left--small-buttons">
                <ChecklistInvitePartner isActive={invitePartnerViewActive} toggleDropdown={onInvitePartnerToggle} renderIconButton />
                {/* Wrap this button to track its clicks */}
                <span onClick={trackPrintChecklistClick}>
                  <ButtonIconSquare
                    role="link"
                    href={`/wedding/print/checklist${filterParams}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    iconClassName="zola-ui-icon-print"
                    secondary
                    className="checklist__nav--leftButtons"
                  />
                </span>
                <ButtonIconSquare
                  onClick={showSettingsModal}
                  iconClassName="zola-ui-icon-gear"
                  secondary
                  className="checklist__nav--leftButtons"
                />
              </div>
            </Media>
          </div>
          <div className="checklist__nav-container__right">
            <ChecklistAddTaskButton />
            <Media query={`(min-width: ${DESKTOP_MIN}px)`}>
              <React.Fragment>
                <div className="checklist__nav-task-buttons">
                  <ChecklistCompleteTaskButton />
                  <ChecklistDeleteTaskButton className="checklist__nav--deleteButton" />
                </div>
                <div className="checklist__nav__navigate--container visible-md visible-lg">
                  <ChecklistTaskNavigationButtons />
                </div>
              </React.Fragment>
            </Media>
            <Media query={`(max-width: ${TABLET_MAX}px)`}>
              <React.Fragment>
                <ChecklistOverflowMenu
                  menuItems={mobileOverflowMenuItems}
                  onMenuItemClick={this.handleDropdownSelect}
                  menuPositionX="right"
                />
                <ChecklistInvitePartner isActive={invitePartnerViewActive} toggleDropdown={onInvitePartnerToggle} />
              </React.Fragment>
            </Media>
          </div>
        </div>
      </Sticky>
    );
  }
}

ChecklistNav.propTypes = {
  className: PropTypes.string,
  filterParams: PropTypes.string,
  trackPrintChecklistClick: PropTypes.func,
};

ChecklistNav.defaultProps = {
  className: '',
  trackPrintChecklistClick: () => {},
};

export default ChecklistNav;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistNav/ChecklistNav.jsx